class BcQuizSection {
  constructor(root) {
    this.root = root;
    this.questions = Array.from(root.querySelectorAll('[data-question-step]'));
    this.resultsStage = root.querySelector('[data-results-stage]');
    this.resultPanels = Array.from(root.querySelectorAll('[data-result-panel]'));
    this.emptyResult = root.querySelector('[data-result-empty]');
    this.backButtons = Array.from(root.querySelectorAll('[data-quiz-back]'));
    this.restartButtons = Array.from(root.querySelectorAll('[data-quiz-restart]'));
    this.hints = Array.from(root.querySelectorAll('[data-quiz-hint]'));
    this.currentIndex = 0;
    this.answers = [];

    if (this.questions.length === 0 || !this.resultsStage) return;

    this.bind();
    this.render();
  }

  bind() {
    this.questions.forEach((question, index) => {
      question.querySelectorAll('[data-answer]').forEach((answerButton) => {
        answerButton.addEventListener('click', () => this.selectAnswer(index, answerButton));
      });
    });

    this.backButtons.forEach((button) => {
      button.addEventListener('click', () => this.goBack());
    });
    this.restartButtons.forEach((button) => button.addEventListener('click', () => this.restart()));
  }

  selectAnswer(index, button) {
    const resultKey = button.dataset.resultKey || '1';
    const question = this.questions[index];
    question.querySelectorAll('[data-answer]').forEach((item) => item.classList.remove('is-selected'));
    button.classList.add('is-selected');
    this.answers[index] = resultKey;

    if (index === this.questions.length - 1) {
      this.showResults();
      return;
    }

    this.transitionQuestion(index, index + 1);
  }

  transitionQuestion(fromIndex, toIndex) {
    const current = this.questions[fromIndex];
    const next = this.questions[toIndex];
    if (!current || !next) return;

    current.classList.add('is-leaving');

    window.setTimeout(() => {
      current.classList.remove('is-active', 'is-leaving');
      next.classList.add('is-active');
      this.currentIndex = toIndex;
      this.render();
    }, 220);
  }

  goBack() {
    if (this.currentIndex === 0) return;

    const current = this.questions[this.currentIndex];
    const prev = this.questions[this.currentIndex - 1];
    this.answers[this.currentIndex] = null;

    current.classList.add('is-leaving');
    window.setTimeout(() => {
      current.classList.remove('is-active', 'is-leaving');
      prev.classList.add('is-active');
      this.currentIndex -= 1;
      this.render();
    }, 220);
  }

  getWinningResultKey() {
    const scores = {};
    let winner = this.answers[this.answers.length - 1] || '1';

    this.answers.forEach((key) => {
      if (!key) return;
      scores[key] = (scores[key] || 0) + 1;
      if (scores[key] >= (scores[winner] || 0)) {
        winner = key;
      }
    });

    return winner;
  }

  showResults() {
    const current = this.questions[this.currentIndex];
    current.classList.add('is-leaving');

    window.setTimeout(() => {
      current.classList.remove('is-active', 'is-leaving');
      this.resultsStage.classList.add('is-active');
      const winner = this.getResolvedResultKey();

      this.resultPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.resultKey === winner);
      });
      if (this.emptyResult) {
        this.emptyResult.classList.toggle('is-active', !winner);
      }

      this.backButtons.forEach((button) => button.setAttribute('hidden', 'hidden'));
      this.hints.forEach((hint) => hint.setAttribute('hidden', 'hidden'));
    }, 220);
  }

  getResolvedResultKey() {
    const winner = this.getWinningResultKey();
    const hasWinningPanel = this.resultPanels.some((panel) => panel.dataset.resultKey === winner);

    if (hasWinningPanel) return winner;

    return this.resultPanels[0]?.dataset.resultKey || null;
  }

  restart() {
    this.resultsStage.classList.remove('is-active', 'is-leaving');
    this.resultPanels.forEach((panel) => panel.classList.remove('is-active'));
    if (this.emptyResult) {
      this.emptyResult.classList.remove('is-active');
    }
    this.questions.forEach((question, index) => {
      question.classList.toggle('is-active', index === 0);
      question.classList.remove('is-leaving');
      question.querySelectorAll('[data-answer]').forEach((answer) => answer.classList.remove('is-selected'));
    });
    this.answers = [];
    this.currentIndex = 0;
    this.render();
  }

  render() {
    this.backButtons.forEach((button) => {
      button.toggleAttribute('disabled', this.currentIndex === 0);
      button.removeAttribute('hidden');
    });
    this.hints.forEach((hint) => hint.removeAttribute('hidden'));
  }
}

function initBcQuizSections() {
  document.querySelectorAll('[data-bc-quiz]').forEach((quiz) => {
    if (quiz.dataset.bcQuizInit === 'true') return;
    quiz.dataset.bcQuizInit = 'true';
    new BcQuizSection(quiz);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBcQuizSections);
} else {
  initBcQuizSections();
}

document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('[data-bc-quiz]').forEach((quiz) => {
    quiz.dataset.bcQuizInit = 'false';
  });
  initBcQuizSections();
});
